import { Colors } from '@estee/elc-base-theme';

export const spinnerContainerTheme = `
    background-color: ${Colors.whiteMediumEmphasis};
`;
